import React from 'react';
import { Box, TextField, useMediaQuery, useTheme } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';


interface ReadOnlyUserDetailsFormProps {
    userDetails: { firstName: string; lastName: string; studentCode: string };
}

const ReadOnlyUserDetailsForm: React.FC<ReadOnlyUserDetailsFormProps> = ({ userDetails }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
       
            <Box
                display="flex"
                flexDirection="column"
                gap={2}
                p={2}
                bgcolor="#f9f9f9"
                borderRadius={2}
                boxShadow={1}
                data-testid="user-details-form-container"
            >
                {/* Section 1: User Name */}
                <Box
                    display="flex"
                    flexDirection={isMobile ? 'column' : 'row'}
                    gap={2}
                    data-testid="user-details-form-name-section"
                >
                    <TextField
                        label="Student First Name"
                        variant="standard"
                        value={userDetails.firstName}
                        disabled
                        fullWidth
                    />
                    <TextField
                        label="Student Last Name"
                        variant="standard"
                        value={userDetails.lastName}
                        disabled
                        fullWidth
                    />
                </Box>

                {/* Section 2: Claim Code */}
                <Box
                    display="flex"
                    flexDirection={isMobile ? 'column' : 'row'}
                    gap={2}
                    data-testid="user-details-form-claimcode-section"
                >
                    <TextField
                        label="Student Code"
                        variant="standard"
                        value={userDetails.studentCode}
                        disabled
                        fullWidth
                    />
                </Box>
            </Box>
    );
};

export default ReadOnlyUserDetailsForm;
